import { Injectable, inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { LoyaltyCollectionService } from '@src/api';
import { AlertService } from '@src/core/services';

import { LpCollectionStatisticsStoreService } from './store';

@Injectable({
  providedIn: 'root',
})
export class LpCollectionStatisticsService {
  private readonly alertService = inject(AlertService);
  private readonly loyaltyCollectionService = inject(LoyaltyCollectionService);
  private readonly lpCollectionStatisticsStore = inject(LpCollectionStatisticsStoreService);

  getStatistics(collectionId: string, unionId?: string) {
    return this.loyaltyCollectionService.getLoyaltyCollectionStatisticsById(collectionId, unionId).pipe(
      catchError(err => {
        this.alertService.error(err);
        return throwError(() => err);
      }),
      tap(statistics => {
        this.lpCollectionStatisticsStore.setData(collectionId, statistics);
      }),
    );
  }
}
